/**
 * Canonical capability id for workflow ASL Resource fields (suffix after "agent:", "tool:", etc.).
 * Matches server list/detail: fqcn = app_key + "/" + name when present.
 */
export function getWorkflowCapabilityFqcn(
    entity: { fqcn?: string; app_key?: string; name: string },
    fallbackAppKey?: string,
): string {
    if (entity.fqcn) return entity.fqcn;
    const app = entity.app_key ?? fallbackAppKey;
    if (app) return `${app}/${entity.name}`;
    return entity.name;
}
